import { Navigate, useRoutes } from 'react-router-dom';
import Callback from './components/Callback';
import Layout from './components/layout/Layout';
import Monitor from './components/monitor/Monitor';
import Report from './components/report/Report';
import Dashboard from './components/dashboard/Dashboard';
// import MyEOC from './components/myeoc/MyEOC';
import UserPermissionPage from './components/UserPermissionPage';
import MyEOC from './components/myeoc_remake/MyEOC';

export default function Router() {
    return useRoutes([
        {
            path: '/',
            element: <Layout />,
            children: [
                { path: '', element: <Navigate to="monitor" replace/> },
                // { path: '', element: <Dashboard/> }
                { path: 'dashboard',  element: <Dashboard />},
                { path: 'monitor',  element: <Monitor />},
                { path: 'myeoc',  element: <MyEOC />},
                { path: 'report',  element: <Report />},
            ]
        },
        { path: '/permission', element: <UserPermissionPage />},
        { path: '/callback', element: <Callback /> },
        // { path: '/404', element: <NotFound404 /> },
        // { path: '/*', element: <Navigate to="/404" replace /> }
    ]);
}